import React from 'react';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import ButtonGroup from '@zg-rentals/multibrand-ui/lib/ButtonGroup';
import Button from '@zg-rentals/multibrand-ui/lib/Button';

// Stylesheets
import 'app/shared/components/Graphs/style.scss';

const propTypes = {
    title: PropTypes.string,
    firstTabTitle: PropTypes.string,
    secondTabTitle: PropTypes.string,
    showTabs: PropTypes.bool,
    activeIndex: PropTypes.number,
    isLoading: PropTypes.bool,
    onTabClick: PropTypes.func,
};

const defaultProps = {
    title: '',
    firstTabTitle: 'Average',
    secondTabTitle: 'Total',
    showTabs: false,
    activeIndex: 0,
    isLoading: false,
    onTabClick: () => {},
};

const GraphTitle = ({
    title, showTabs, onTabClick, firstTabTitle, secondTabTitle, activeIndex, isLoading,
}) => (
    <Row className="Graph-row">
        <Col className="Graph-col" md={12} lg={6} xl={8}>
            <Text type="h4" emphasize={true}>{title}</Text>
        </Col>
        {showTabs && (
            <Col className="Graph-col" md={12} lg={6} xl={4}>
                <ButtonGroup full={true}>
                    <Button
                        full={true}
                        onClick={() => onTabClick(0)}
                        type={activeIndex === 0 ? 'primary' : 'outline'}
                        disabled={isLoading}
                    >
                        {firstTabTitle}
                    </Button>
                    <Button
                        full={true}
                        onClick={() => onTabClick(1)}
                        type={activeIndex === 1 ? 'primary' : 'outline'}
                        disabled={isLoading}
                    >
                        {secondTabTitle}
                    </Button>
                </ButtonGroup>
            </Col>
        )}
    </Row>
);

GraphTitle.propTypes = propTypes;
GraphTitle.defaultProps = defaultProps;

export default GraphTitle;
